import { keyMirror } from "../../../utils";

export default keyMirror(['TOGGLE_MODAL', 'INIT_FORM']);
